import { useUILanguage } from 'hooks/useUILanguage';
import { SearchFooter } from './SearchFooter';
import { SearchHeader } from './SearchHeader';
import { SearchOverlay } from './SearchOverlay';
import { SearchSuggestion } from './SearchSuggestion';
import styles from './CustomSearch.module.scss';
import React from 'react';
import { SearchResult } from './useCustomSearch';
import { CustomSearch as CustomSearchConf } from 'types/yleHeader';
import { Service } from '@yleisradio/areena-types';

interface SearchProps {
  searchConfig: CustomSearchConf;
}

const SEARCH_COLUMN_LIMIT = 7;

export const CustomSearch: React.FunctionComponent<SearchProps> = ({
  searchConfig,
}) => {
  const language = useUILanguage();

  if (searchConfig.searchResults.length < 1) {
    return (
      <div
        id={`search-result-container`}
        className={styles.search_result_container_empty}
      />
    );
  }

  const mapSearchResultsColumn = (
    searchColumn: SearchResult,
    isTvColumn: boolean
  ) => {
    const service = searchColumn.service as Service;

    return (
      <div className={styles.search__column} key={service}>
        <SearchHeader service={service} language={language} />
        {searchColumn.results.map((card, i) => {
          const columnOffset = isTvColumn ? i : i + SEARCH_COLUMN_LIMIT;
          const isSelected =
            columnOffset === searchConfig.cursor() ? true : false;
          if (i < SEARCH_COLUMN_LIMIT) {
            return (
              <SearchSuggestion
                key={`${card.title + service + i}`}
                card={card}
                service={service}
                isSelected={isSelected}
              />
            );
          }
        })}
      </div>
    );
  };

  return (
    <div
      id={`search-result-container`}
      className={styles.search_result_container}
    >
      <div id="search-results" className={styles.search}>
        <SearchOverlay />
        {searchConfig.searchResults.map((searchColumn, i) => {
          const isTvColumn = i === 0 ? true : false;
          return mapSearchResultsColumn(searchColumn, isTvColumn);
        })}
        <SearchFooter language={language} query={searchConfig.query()} />
      </div>
    </div>
  );
};
